export const getRandomArrayIndex = (array: any[]) => {
  return Math.floor(array.length * Math.random());
};
